<template lang="pug">
  .page.page_offset_top.page_offset_bottom
    .page-meta
      .container
        .page-meta__inner.page-meta__inner_top
          breadcrumbs
          social.page-meta__social-list(theme="blue")
    .page-about
      .container
        .page-mediacenter__container
          h1.title.title_size_l.text_center.page-about__title История BelkaCar
          .jumbotron.page-about__jumbotron
            .jumbotron__image
              img(src="/static/img/about-page-bg.jpg", alt="")
          p.text_theme_gray Однажды ночью, в 2013 году, сидя на кухне в Москве после дня обучения в Стартап академии Сколково, Екатерина Макарова и Елена Мурадова решили позвонить своей, в прошлом, однокурснице по Калифорнийскому государственному университету, Лориане Сардар. Она жила уже несколько лет в Милане, где в последнее время очень бурно начал развиваться каршеринг. Вдохновленные опытом Милана, они решили попробовать сделать это в Москве. Москва, в то время, задыхалась от пробок, и&nbsp;только начали появляться платные парковки.
          .page-about__row
            .page-about__col.page-about__content
              p.text_theme_gray.page-about__text Они были убеждены, что идея приживется в Москве и окажет благоприятное влияние на транспортную среду, так как средний москвич использовал личный автомобиль всего 4 % времени, а 96 % автомобиль простаивал мертвым грузом, но в тоже время каждый день на переполненных дорогах Москвы появлялось 600 новых автомобилей. Стало понятно: у этой проблемы должно быть какое-то решение, пришло время каршеринга.
              p.text_theme_gray.page-about__text Но мечте суждено было осуществиться только в конце 2015 года, когда появилась возможность финансировать проект.
            .page-about__col.page-about__image
              .jumbotron
                .jumbotron__image
                  img(src="/static/img/about-page-bg-2.jpg", alt="")
          section.about-company-section
            h2.title.title_size_l.text_center.about-company-section__title О компании BelkaCar
            p.text_theme_gray.about-company-section__text BelkaCar — это компания, предоставляющая сервис, который позволяет людям находить рядом с собой доступные автомобили и арендовать их через мобильное приложение, причём очень быстро, удобно и недорого. Компания основана в 2015 году Екатериной Макаровой, Лорианой Сардар и Еленой Мурадовой, вместе получившими MBA в Калифорнийском государственном университете. С первого дня запуска сервиса компания выставила 100 автомобилей в Москве.
            .grid-column-3.about-company-section__grid-column-3
              p.text_theme_gray Сервис работает по концепции «все включено» — это означает, что парковка, бензин и страховка уже включены в стоимость услуги. BelkaCar работает как с частными, так и с корпоративными клиентами, а также большое внимание уделяет работе с университетами.
              p.text_theme_gray Основной ценностью компании является технологичность и открытость, поэтому у компании молодая и амбициозная команда, средний возраст сотрудника — 25 лет.
              p.text_theme_gray Собственная ИТ-платформа позволяет предоставлять качественный сервис и оперативно реагировать на обратную связь от клиентов.
          section.founders-section
            h2.title.title_size_l.text_center.founders-section__title Основатели
            .founders-list
              .founders-item
                .founders-item__image
                  img(src="/static/img/emakarova-medium.jpg", alt="")
                .founders-item__content
                  h3.title.title_size_m.founders-item__name Екатерина Макарова
                  p.text_theme_gray Отвечает за маркетинговую стратегию и ИТ-инфраструктуру. В течение 15 лет курировала маркетинговые коммуникации в крупных ИТ-компаниях, участвовала в продвижении продуктовых портфелей Intel, Microsoft, IBM и др. В 2009 году получила степень MBA в California State University, East Bay. В 2013 году закончила Стартап академию Сколково.
              .founders-item
                .founders-item__image
                  img(src="/static/img/lsardar-medium.jpg", alt="")
                .founders-item__content
                  h3.title.title_size_m.founders-item__name Лориана Сардар
                  p.text_theme_gray Отвечает за финансовый блок и операционную деятельность компании, взаимоотношения с инвесторами (IR) и GR. Ранее управляла проектами в компании «Вымпелком», много лет работала в инвестиционной компании, отвечала за инвестиционный анализ проектов. В 2009 году получила степень MBA в California State University, East Bay. В 2013 году закончила магистратуру SDA Bocconi.
              .founders-item
                .founders-item__image
                  img(src="/static/img/emuradova-medium.jpg", alt="")
                .founders-item__content
                  h3.title.title_size_m.founders-item__name Елена Мурадова
                  p.text_theme_gray Отвечает за корпоративные продажи, взаимоотношения с&nbsp;ключевыми партнёрами, а также за юридический блок. Имеет многолетний опыт работы в инвестиционной и банковской сферах. С 2012 года управляет собственным бизнесом. В 2009 году получила степень MBA в California State University, East Bay.
</template>

<script>
import Social from './../components/Social'

export default {
  name: 'About',
  components: { Social },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/About.vue